// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"4a113e73","92":"7692aac9","131":"3f6d7b15","258":"9d027442","291":"5764e0e3","890":"f4b6ea4e"}[chunkId] + ".css";
};